<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle
      cx="11"
      cy="11"
      r="8"
      class="animate-draw-circle stroke-current"
      stroke-width="2"
      pathLength="1"
      stroke-dasharray="1"
      stroke-dashoffset="1"
    />
    <path
      d="M 21 21 L 16.7 16.7"
      class="animate-draw-circle stroke-current"
      stroke-width="2"
      stroke-linecap="round"
      pathLength="1"
      stroke-dasharray="1"
      stroke-dashoffset="1"
    />
    <path
      d="M 8.5 8.5 L 13.5 13.5"
      class="animate-draw-check stroke-current"
      stroke-width="2"
      stroke-linecap="round"
      pathLength="1"
      stroke-dasharray="1"
      stroke-dashoffset="1"
    />
    <path
      d="M 13.5 8.5 L 8.5 13.5"
      class="animate-draw-cross-2 stroke-current"
      stroke-width="2"
      stroke-linecap="round"
      pathLength="1"
      stroke-dasharray="1"
      stroke-dashoffset="1"
    />
  </svg>
</template>
